import { Injectable } from '@angular/core';
import 'ceotr-web-common/helpers/extensions';
import * as moment from "moment";

@Injectable({
  providedIn: 'root'
})
export class TimezoneService {

  constructor() { }

  public timezone = {
    // @ts-ignore
    short: moment.utc().zoneAbbr(),
    // @ts-ignore
    long: moment.utc().zoneName()
  };
}

export interface Timezone {
  short: string
  long: string
}
